// A custom hook that builds on useLocation to parse

import { useLocation } from "react-router";
import { useMemo } from "react";

// the query string for you.
const useQuery = () => {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
};

export default useQuery;
